<template>
  <div></div>
</template>

<script>
export default {
  name: "OrderStatus",

  beforeRouteEnter(to, from, next) {
    next({ path: "/uploads", query: { type: "order_status" } });
  },
};
</script>
